import { useEffect, useRef, useState } from 'react';
import { useAuthStore } from '../stores/authStore';
/** Explicit playback/download of input already held on this device; never uploads it. */
export default function RecordingRecovery({ blob, ownerId }: { blob: Blob; ownerId: string | undefined }) {
  const userId = useAuthStore(state => state.user?.id);
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const audio = useRef<HTMLAudioElement | null>(null);
  const playing = useRef<HTMLAudioElement | null>(null);
  useEffect(() => {
    if (!ownerId || ownerId !== userId) { setUrl(null); return; }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => {
      if (playing.current && !playing.current.paused) playing.current.pause();
      playing.current = null;
      URL.revokeObjectURL(objectUrl);
    };
  }, [blob, ownerId, userId]);
  const permitted = () => !!ownerId && useAuthStore.getState().user?.id === ownerId;
  const play = async () => {
    if (!permitted() || !audio.current) return;
    const player = audio.current; playing.current = player;
    try { await player.play(); if (!permitted()) player.pause(); }
    catch { setError('This browser could not play the recording. Its original audio remains available to download.'); }
  };
  if (!url || !ownerId || ownerId !== userId) return null;
  return <div className="space-y-2">
    <audio ref={audio} src={url} aria-label="Recover recording" />
    <button type="button" onClick={() => void play()} className="text-primary underline">Play recording</button>
    <button type="button" onClick={() => { if (audio.current && !audio.current.paused) audio.current.pause(); }} className="text-primary underline">Stop playback</button>
    <a href={url} onClick={event => { if (!permitted()) event.preventDefault(); }} download={`cerebro-recording.${blob.type.includes('mp4') ? 'mp4' : 'webm'}`} className="text-primary underline">Download recording</a>
    {error && <p role="alert">{error}</p>}
  </div>;
}
